const Vr1 = () => {

    return (
      <div style={{ width: "100%", height: "100vh" }}>
        <iframe
          src={`https://hitimperial.github.io/VR360-9/PNG%20n.3/3d%209-3/publish%209-3/`}
          width="100%"
          height="100%"
          style={{ border: "none" }}
          allowFullScreen
          title="VR 9 Level 3 Tour"
        ></iframe>
      </div>
    );
};

export default Vr1;
